<template>
  <!-- 保单管理 -->
  <div class="main-container insuredOrder">
    <div class="content">
      <div class="search-box">
        <div class="input-item">
          <span class="label">保险公司</span>
          <Select v-model="search.companyId" clearable filterable @on-change="companyChange">
            <Option v-for="(item, index) in companyList" :value="item.id" :key="index">{{ item.name }}</Option>
          </Select>
        </div>
        <div class="input-item">
          <span class="label">保险产品</span>
          <Select v-model="search.productId" clearable filterable>
            <Option v-for="item in productList" :value="item.id" :key="item.id">{{ item.name }}</Option>
          </Select>
        </div>
        <div class="input-item">
          <span class="label">保单编号</span>
          <Input type="text" v-model="search.policyNo" clearable placeholder="请输入" />
        </div>
        <div class="input-item">
          <!-- <span class="label">生效时间</span> -->
          <div class="label" style="width: 180px">
            <Select v-model="search._timeType">
              <Option value="effectDate">生效日期</Option>
              <Option value="signDate">签单日期</Option>
            </Select>
          </div>
          <DatePicker
            type="daterange"
            split-panels
            separator="至"
            :transfer="true"
            :editable="false"
            placement="bottom"
            format="yyyy-MM-dd"
            placeholder="选择日期"
            :value="search._time"
            @on-change="$set(search, '_time', $event)"
          ></DatePicker>
        </div>
        <div class="input-item">
          <span class="label">投保人</span>
          <Input type="text" v-model="search.name" clearable placeholder="请输入" />
        </div>
        <div class="input-item">
          <span class="label">受保人</span>
          <Input type="text" v-model="search.insuranceName" clearable placeholder="请输入" />
        </div>
        <div class="input-item">
          <span class="label">{{ isIFA ? '归属团队' : '归属转介人' }}</span>
          <select-tree
            v-model="search.id"
            type="5"
            url="/buz/merchant/read/tree"
            @change="changeTenant"
            :params="{ nodeType: 0 }"
            :isAll="true"
            ref="selectTree"
          ></select-tree>
        </div>
        <div class="input-item">
          <span class="label">归属员工</span>
          <Select v-model="search.agentId" clearable filterable>
            <Option v-for="item in userList" :value="item.id" :key="item.id">{{ item.name }}</Option>
          </Select>
        </div>
        <div class="input-item">
          <span class="label">新单缴费状态</span>
          <Select v-model="search.payStatus" clearable filterable multiple>
            <Option v-for="item in POLICY_PAY_STATUS" :value="Number(item.value)" :key="Number(item.value)">{{ item.txt }}</Option>
          </Select>
        </div>
        <div class="input-item">
          <span class="label">是否转单</span>
          <Select v-model="search.isTransferOrder" clearable filterable>
            <Option :value="1">是</Option>
            <Option :value="0">否</Option>
          </Select>
        </div>
        <div class="btn-item">
          <Button type="primary" @click="(pageNum = 1), getList()">查询</Button>
          <Button type="primary" ghost @click="resetSearch">重置</Button>
        </div>
      </div>

      <Tabs v-model="status" :animated="false" @on-click="onChangeTab($event, 'main')">
        <div class="tools-box" slot="extra">
          <Button type="primary" ghost @click="handleExport">导出</Button>
        </div>
        <TabPane :label="() => getNumText('全部', 'null')" name="" />
        <TabPane v-for="item in POLICY_STATUS" :label="() => getNumText(item.txt, item.value)" :name="item.value" :key="item.value" />
      </Tabs>
      <Tabs v-if="policySubStatusList.length" v-model="subStatus" class="second-tabs" :animated="false" @on-click="onChangeTab($event, 'sub')">
        <TabPane label="全部" name="*" />
        <TabPane v-for="item in policySubStatusList" :label="item.txt" :name="item.value" :key="item.value" />
      </Tabs>
      <div class="count-box">
        <div class="count-item">
          <span class="label">规模保费：</span>
          <span class="num">{{ statistics.totalFee || 0 }}美元</span>
        </div>
        <div class="count-item">
          <span class="label">标保：</span>
          <span class="num">{{ statistics.totalFyb || 0 }}美元</span>
        </div>
      </div>

      <div class="table-box">
        <loading :isShow="tableLoading" />
        <Table :columns="columns" :data="tableData">
          <template slot-scope="{ row }" slot="fee">
            <span>{{ row.fee }}</span>
            <lzDicTxt dicType="CURRENCY_TYPE" :dicCode="row.currencyType" />
            <span v-if="row.fee && (row.paymentPeriod || row.paymentType)">/</span>
            <span>{{ row.paymentPeriod }}</span>
            <lzDicTxt v-if="row.paymentType" :dicCode="row.paymentType" dicType="GUARANTEE_TYPE"></lzDicTxt>
            <span v-else>年</span>
          </template>
          <!-- 保单号 -->
          <template slot-scope="{ row }" slot="policyNo">
            <Icon type="md-star" style="margin-right: 4px;" v-if="row.isReferral == 1" />
            <span class="dian-text">{{ row.policyNo }}</span>
            <span class="my-tag blue2 min" v-if="row.isTransferOrder == 1" style="margin-left: 4px">转单</span>
          </template>
          <!-- 保单状态 -->
          <template slot-scope="{ row }" slot="status">
            <policyStatusTxt :formData="row" :class="row.status == 1 ? 'my-tag blue tr' : ''" />
          </template>
          <!-- 新单缴费状态 -->
          <template slot-scope="{ row }" slot="payStatus">
            <span v-if="row.payStatus == '0'" class="my-tag red">未缴费</span>
            <lzDicTxt v-else dicType="POLICY_PAY_STATUS" :dicCode="row.payStatus"></lzDicTxt>
          </template>
          <template slot-scope="{ row }" slot="action">
            <span class="table-btn" @click="editModal('read/detail', row)">详情</span>
            <span class="table-btn" @click="handleViewStatusRecord(row)">新单进度</span>
            <template v-if="userInfo.showCommission == 1">
              <Poptip v-if="row.isRecordLedger * 1 === 0" placement="left" transfer :max-width="100" trigger="hover" content="积分记录暂未生成，请联系商务老师">
                <span class="table-btn" :class="{ disabled: row.isRecordLedger * 1 === 0 }" @click="handleViewCommission(row)">{{
                  isIFA ? '佣金记录' : '积分台账'
                }}</span>
              </Poptip>
              <span v-else class="table-btn" :class="{ disabled: row.isRecordLedger * 1 === 0 }" @click="handleViewCommission(row)">{{
                isIFA ? '佣金记录' : '积分台账'
              }}</span></template
            >
          </template>
        </Table>

        <Page
          :total="total"
          :current.sync="pageNum"
          :page-size="pageSize"
          show-total
          show-sizer
          style="text-align: center; margin-top: 20px"
          @on-change="getList"
          @on-page-size-change="(pageSize = $event), getList()"
        />
      </div>
    </div>

    <!-- 积分记录 -->
    <commissionModal ref="commissionModalRef" />

    <changeStatusRecordModal ref="changeStatusRecordModal" />
  </div>
</template>

<script>
var vm;
import selectTree from '@/components/system/selectTree3';
import lzDicTxt from '@/components/commons/lzDicTxt';
import lzSelect from '@/components/commons/lzSelect';
import { pageTool, common } from '@/api/mixins';
import { config } from './order.config.js';
import commissionModal from './components/commissionModal/index';
import _ from 'lodash';
import { getInsureOrderList } from '@/api/httpList';
import changeStatusRecordModal from './components/changeStatusRecordModal.vue';
import policyStatusTxt from '@/components/commons/policyStatusTxt';

const dicData = JSON.parse(localStorage.dicData); // 排序的字典 数组结构
const userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}') || {};
console.log(dicData.POLICY_STATUS);
export default {
  mixins: [pageTool, common, config],
  components: {
    selectTree,
    lzSelect,
    lzDicTxt,
    commissionModal,
    changeStatusRecordModal,
    policyStatusTxt
  },
  props: {},
  data() {
    return {
      userList: [],
      tableLoading: false, //表格loading
      search: {
        orderCode: 2, // 默认签单日期
        sortNo: 2, // 默认倒序
        payStatus: [],
        _timeType: 'signDate'
      },
      statistics: {},
      status: '',
      subStatus: '*',
      themeList: [],
      searchLoading: false,
      tableData: [], //表格数据
      total: 0, //表格记录数
      pageSize: 10, //页容量
      pageNum: 1, //当前页
      userInfo: userInfo, //用户信息
      POLICY_STATUS: dicData['POLICY_STATUS'], // 保单状态
      POLICY_PAY_STATUS: dicData['POLICY_PAY_STATUS'], // 新单缴费状态
      productList: [], // 产品列表
      companyList: [], //保司列表
      columns: [],
      uploadModal: false,
      uploadTempUrl: 'javascript:;'
    };
  },
  computed: {
    isIFA() {
      return this.userInfo.isIFA;
    },
    policySubStatusList() {
      if (!this.status) return [];
      const POLICY_SUB_STATUS = dicData['POLICY_SUB_STATUS'];
      return (
        POLICY_SUB_STATUS &&
        POLICY_SUB_STATUS.filter(item => {
          // 获取当前保单状态对应的子状态
          const min = this.status + '00';
          const max = this.status + '99';
          return Number(item.value) >= Number(min) && Number(item.value) <= Number(max);
        })
      );
    }
  },
  created() {
    vm = this;
    this.cachedSearchData = Object.assign({}, this.search);
  },
  methods: {
    changeTenant(data) {
      console.log(data);
      if (data.nodeType == 1) {
        this.search.groupId = '';
        this.search.tenantId = data.id;
      } else if (data.nodeType == 2) {
        this.search.groupId = data.id;
        this.search.tenantId = data.parentId;
      } else {
        this.search.groupId = '';
        this.search.tenantId = '';
      }
      this.search.agentId = '';
    },
    handleViewCommission(row) {
      if (row.isRecordLedger * 1 === 1) {
        this.$refs.commissionModalRef.open({ id: row.id, code: row.code });
      }
    },
    onChangeTab(tabName, t) {
      this.pageNum = 1;
      if (t === 'main') {
        this.subStatus = '*';
      }
      this.getList();
    },
    // 重置搜索
    resetSearch() {
      this.search = Object.assign({}, this.cachedSearchData);
      this.pageNum = 1;
      this.getList();
    },
    // 查询申请人
    getUserList() {
      this.$http({
        url: '/buz/userBase/list',
        type: 'POST',
        data: {
          selectSub: 1,
          tenantId: this.search.tenantId
        }
      }).then(res => {
        this.userList = res.data.filter(i => i.ifaType != 2);
      });
    },
    formatParams(params) {
      if (params._time && Array.isArray(params._time) && params._time.length) {
        if (params._timeType === 'effectDate') {
          params.effectDateStart = params._time[0];
          params.effectDateEnd = params._time[1];
        } else if (params._timeType === 'signDate') {
          params.signDateStart = params._time[0];
          params.signDateEnd = params._time[1];
        }
      }
      delete params._timeType;
      delete params._time;
      delete params.id;
      if (this.status) params.status = this.status;

      if (this.policySubStatusList.length) {
        params.subStatus = this.subStatus;
      }
      if (params.subStatus === '*') {
        params.subStatus = '';
      }
    },

    //获取订单
    async getList() {
      this.tableLoading = true;
      const params = {
        ...this.search,
        pageNo: this.pageNum,
        pageSize: this.pageSize
      };
      this.formatParams(params);
      getInsureOrderList(params)
        .then(res => {
          this.getColumns();
          this.getStatistics();
          this.tableData = res.data;
          this.total = res.total;
          this.tableLoading = false;
        })
        .catch(e => {
          console.log(e);
          this.tableLoading = false;
        });
    },
    // 获取统计数据
    getStatistics() {
      const params = JSON.parse(JSON.stringify(this.search));
      this.formatParams(params);
      params.countStatus = params.status;
      delete params.status;
      params.countSubStatus = params.subStatus;
      delete params.subStatus;
      this.$http({
        url: '/buz/policy/statistics',
        type: 'POST',
        data: params
      }).then(res => {
        this.statistics = res.data;
      });
    },
    // 获取统计数据文本
    getNumText(text, status) {
      const statusMap = {
        '0': 'invalid', //取消投保
        '1': 'effective', // 已生效
        '2': 'underwriteIng', // 非PENDING
        '3': 'pending', // PENDING
        '5': 'policyHandleSuccess', // 已交单
        '6': 'end', // 已终止
        '7': 'failures', //已失效
        '-1': 'refund' //已退保
      };
      let num = this.statistics[statusMap[status]] || 0;
      if (status == 'null') {
        num += this.statistics.invalid || 0;
        num += this.statistics.effective || 0;
        num += this.statistics.underwriteIng || 0;
        num += this.statistics.pending || 0;
        num += this.statistics.policyHandleSuccess || 0;
        num += this.statistics.end || 0;
        num += this.statistics.refund || 0;
      }
      return (
        <div>
          {text}(<span style="color: #236dff">{num}</span>)
        </div>
      );
    },

    // 查询所有保司
    queryCompanyList() {
      this.$http({
        url: '/buz/insuranceCompany/query/list',
        type: 'GET',
        data: {}
      }).then(res => {
        this.companyList = res.data;
      });
    },
    companyChange() {
      vm.$http({
        url: '/buz/product/query/list',
        type: 'GET',
        data: { companyId: vm.search.companyId }
      }).then(res => {
        vm.productList = res.data;
      });
    },

    // 查询所有保司
    queryProductList() {
      this.$http({
        url: '/buz/product/query/list',
        type: 'GET',
        data: {}
      }).then(res => {
        this.productList = res.data;
      });
    },

    // 新增编辑弹窗
    editModal(reqUrl, row = {}) {
      this.openPageTabTags('/operate/orderManage/insuredOrder/policyDetail', {
        backUrl: this.$route.fullPath,
        id: row.id || '',
        reqUrl,
        timeStr: new Date().getTime()
      });
    },

    // 打开修改状态记录弹窗
    handleViewStatusRecord(row) {
      this.$refs.changeStatusRecordModal.open(row);
    },

    //导入弹窗
    handleImport() {
      vm.uploadModal = true;
      vm.$http({
        url: `/admin/importExcelTemplate/queryTemplate`,
        type: 'GET',
        data: { code: 'admin_policy' }
      })
        .then(res => {
          if (res.httpCode == 1) {
            vm.uploadTempUrl = res.data;
          }
        })
        .catch(e => {});
    },
    //导入结果
    handleSuccess(response) {
      if (response.httpCode == 1) {
        vm.$Notice.success({
          title: '上传成功',
          desc: ''
        });
      } else {
        vm.$Notice.error({
          title: '上传失败',
          desc: response.msg
        });
      }
    },
    handleError(error) {
      vm.$Notice.error({
        title: '上传失败',
        desc: error
      });
    },

    //导出数据
    handleExport() {
      const params = { ...this.search };
      this.formatParams(params);
      vm.$units.downloadFile('/buz/policy/export', params, 'POST');
    }
  },
  async activated() {
    this.getList();
    Promise.all([this.queryCompanyList(), this.queryProductList()]);
    this.getUserList();
  }
};
</script>
<style lang="scss" scoped>
.toolbox {
  line-height: 46px;
  background-color: #f8f8f9;
  border-top: 1px solid #e8eaec;
  border-left: 1px solid #e8eaec;
  border-right: 1px solid #e8eaec;
  .add-btn {
    float: right;
    margin-right: 10px;
  }
}
.insuredOrder {
  /deep/.ivu-dropdown {
    margin: 0 6px !important;
  }
}
.insuredOrder {
  /deep/.ivu-table-cell-slot > div {
    float: initial;
  }
}
.table-btn.disabled {
  color: #ccc;
  cursor: not-allowed;
}
.count-box {
  display: flex;
  gap: 40px;
  padding-top: 5px;
  padding-bottom: 15px;
}
.count-item {
  display: flex;
  align-items: center;
}
.count-item .label {
  font-size: 14px;
  color: #606266;
}
.count-item .num {
  font-size: 14px;
  font-weight: 600;
  color: #236dff;
}
</style>
